<template>
  <svg
    width="208"
    height="200"
    viewBox="0 0 208 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Isolation_Mode" clip-path="url(#clip0_2787_13256)">
      <g id="Group">
        <path
          id="Vector"
          opacity="0.08"
          d="M189.09 189.6C165.86 203.01 128.47 203.51 104.19 190.74L20.0696 147.47C-5.85044 133.83 -6.79044 110.45 18.0096 96.1302L24.1796 92.5702C48.9796 78.2502 89.4796 78.7902 113.1 93.7602L191.05 140.59C213.18 154.61 212.31 176.19 189.08 189.61L189.09 189.6Z"
          fill="black"
        />
        <g id="Group_2">
          <path
            id="Vector_2"
            d="M33.4091 138.26C33.4091 138.26 35.7291 127.96 34.6191 124.09C33.5191 120.24 24.7491 112.6 24.7491 112.6C24.7491 112.6 19.7391 119.24 24.7491 127.3C29.7591 135.36 26.8491 137.36 26.8491 137.36L33.4091 138.26Z"
            fill="#1FAEF0"
          />
          <path
            id="Vector_3"
            d="M33.4688 137.53C33.4688 140.41 31.1388 141.08 28.2588 141.08C25.3788 141.08 23.0488 140.4 23.0488 137.53C23.0488 134.66 25.3788 132.32 28.2588 132.32C31.1388 132.32 33.4688 134.65 33.4688 137.53Z"
            fill="#BA203F"
          />
        </g>
        <g id="Group_3">
          <path
            id="Vector_4"
            d="M182.319 154.711C182.319 154.711 179.999 144.411 181.109 140.541C182.209 136.691 190.979 129.051 190.979 129.051C190.979 129.051 195.989 135.691 190.979 143.751C185.969 151.811 188.879 153.811 188.879 153.811L182.319 154.711Z"
            fill="#1FAEF0"
          />
          <path
            id="Vector_5"
            d="M182.26 153.991C182.26 156.871 184.59 157.541 187.47 157.541C190.35 157.541 192.68 156.861 192.68 153.991C192.68 151.121 190.35 148.781 187.47 148.781C184.59 148.781 182.26 151.111 182.26 153.991Z"
            fill="#BA203F"
          />
        </g>
        <path
          id="Vector_6"
          d="M170.1 157.91C150.86 169.02 126.25 175.55 106.14 164.97L36.3599 125.19C9.24988 108.95 6.62988 59.0898 6.62988 59.0898L199.66 91.7298C208.41 131.5 179.35 152.57 170.09 157.91H170.1Z"
          fill="#BDE6FF"
        />
        <path
          id="Vector_7"
          d="M183.7 121.141C161.93 133.711 126.9 134.171 104.15 122.201L25.3297 81.6605C1.03971 68.8805 0.159714 46.9705 23.3997 33.5605L29.1797 30.2205C52.4197 16.8005 90.3597 17.3105 112.5 31.3305L185.54 75.2105C206.27 88.3405 205.46 108.571 183.7 121.141Z"
          fill="#E3F3FF"
        />
        <path
          id="Vector_8"
          d="M142.949 122C129.979 122 117.669 119.28 108.279 114.34L29.4692 73.7996C20.6492 69.1596 15.5292 63.1396 15.4092 57.2696C15.2992 51.7096 19.8292 45.8596 27.8392 41.2396L33.6192 37.8996C43.1692 32.3796 56.0592 29.3496 69.9092 29.3496C84.4492 29.3496 98.2392 32.8096 107.749 38.8296L180.789 82.7096C187.929 87.2296 191.799 92.5996 191.689 97.8296C191.579 103.26 187.049 108.95 179.259 113.45C169.849 118.88 156.609 122 142.949 122Z"
          fill="#8FD4FF"
        />
        <path
          id="Vector_9"
          d="M180.659 102.26L107.619 58.3804C98.1091 52.3604 84.3191 48.9004 69.7791 48.9004C55.2391 48.9004 43.0391 51.9404 33.4891 57.4504L27.7091 60.7904C24.4891 62.6504 21.8491 64.7004 19.8291 66.8604C22.1791 69.3604 25.3791 71.7204 29.3391 73.8004L108.159 114.34C117.539 119.28 129.859 122 142.829 122C156.489 122 169.719 118.88 179.139 113.45C182.349 111.6 184.999 109.54 187.019 107.38C185.339 105.6 183.219 103.88 180.669 102.26H180.659Z"
          fill="#43BCFF"
        />
        <path
          id="Vector_10"
          d="M69.7693 85.4512C64.4893 85.4512 59.3593 85.8912 54.4893 86.7512L108.139 114.341C117.519 119.281 129.839 122.001 142.809 122.001C145.869 122.001 148.909 121.841 151.889 121.531L107.609 94.9312C98.0993 88.9112 84.3093 85.4512 69.7693 85.4512Z"
          fill="#399EFF"
        />
        <path
          id="Vector_11"
          d="M36.1094 46.5703C36.1094 48.6403 34.6494 51.1503 32.8594 52.1903C31.0594 53.2303 29.6094 52.3903 29.6094 50.3303C29.6094 48.2703 31.0694 45.7503 32.8594 44.7103C34.6594 43.6703 36.1094 44.5103 36.1094 46.5703Z"
          fill="#143684"
        />
        <g id="Group_4">
          <path
            id="Vector_12"
            d="M125.789 185.91C125.789 185.91 121.239 172.74 121.239 168.65C121.239 164.56 125.699 160.32 128.459 160.32C131.219 160.32 135.819 165.45 135.679 169.09C135.529 172.94 131.249 185.91 131.249 185.91H125.799H125.789Z"
            fill="#1FAEF0"
          />
          <path
            id="Vector_13"
            d="M122.859 188.14C122.859 191.02 125.189 191.69 128.069 191.69C130.949 191.69 133.279 191.01 133.279 188.14C133.279 185.27 130.949 182.93 128.069 182.93C125.189 182.93 122.859 185.26 122.859 188.14Z"
            fill="#BA203F"
          />
        </g>
      </g>
      <g id="Group_5">
        <g id="Group_6">
          <path
            id="Vector_14"
            d="M38.8704 37.3603H33.2504V30.9303L21.1504 23.9403L23.9604 19.0703L37.4704 26.8703C38.3404 27.3703 38.8804 28.3003 38.8804 29.3103V37.3603H38.8704Z"
            fill="#2C89FF"
          />
          <path
            id="Vector_15"
            d="M38.0401 36.3104C39.1401 36.9404 39.1401 37.9704 38.0401 38.6004C36.9401 39.2304 35.1701 39.2304 34.0701 38.6004C32.9701 37.9704 32.9701 36.9404 34.0701 36.3104C35.1701 35.6804 36.9401 35.6804 38.0401 36.3104Z"
            fill="#2C89FF"
          />
          <path
            id="Vector_16"
            d="M24.5904 20.3812C24.5904 21.6512 23.7004 23.1912 22.6004 23.8212C21.5004 24.4612 20.6104 23.9412 20.6104 22.6812C20.6104 21.4212 21.5004 19.8712 22.6004 19.2412C23.7004 18.6012 24.5904 19.1212 24.5904 20.3812Z"
            fill="#2C89FF"
          />
        </g>
        <path id="Vector_17" d="M26.2006 15.7109H20.6006V22.6809H26.2006V15.7109Z" fill="#2C89FF" />
        <path
          id="Vector_18"
          d="M25.3809 14.5702C26.4809 15.2002 26.4809 16.2302 25.3809 16.8602C24.2809 17.4902 22.5109 17.4902 21.4109 16.8602C20.3109 16.2302 20.3109 15.2002 21.4109 14.5702C22.5109 13.9402 24.2809 13.9402 25.3809 14.5702Z"
          fill="#2C89FF"
        />
        <g id="Group_7">
          <g id="Group_8">
            <g id="Group_9">
              <path
                id="Vector_19"
                d="M29.5001 1.21035L24.2901 10.9404C24.2901 10.9404 23.4001 10.3704 22.7201 9.96035C22.0401 9.55035 21.6201 8.67035 21.6201 7.41035C21.6201 4.89035 23.3101 1.82035 25.3901 0.560353C26.4301 -0.0696467 27.3701 -0.139647 28.0501 0.280353C28.7301 0.690353 29.5101 1.23035 29.5101 1.23035L29.5001 1.21035Z"
                fill="#399EFF"
              />
              <path
                id="Vector_20"
                d="M30.5097 3.68947C30.5097 6.20947 28.8197 9.27947 26.7397 10.5395C24.6597 11.8095 22.9697 10.7895 22.9697 8.26947C22.9697 5.74947 24.6597 2.67947 26.7397 1.41947C28.8197 0.149472 30.5097 1.16947 30.5097 3.68947Z"
                fill="#2C89FF"
              />
            </g>
            <g id="Group_10">
              <path
                id="Vector_21"
                d="M39.48 9.03086L35.8 15.5609C35.8 15.5609 25.76 9.72086 25.28 9.44086C24.8 9.16086 24.5 8.57086 24.5 7.73086C24.5 6.04086 25.69 3.98086 27.16 3.13086C27.89 2.71086 28.56 2.66086 29.04 2.94086C29.52 3.22086 39.48 9.03086 39.48 9.03086Z"
                fill="#43BCFF"
              />
              <path
                id="Vector_22"
                d="M40.1901 10.7006C40.1901 12.3906 39.0001 14.4506 37.5301 15.3006C36.0601 16.1506 34.8701 15.4706 34.8701 13.7806C34.8701 12.0906 36.0601 10.0306 37.5301 9.18064C39.0001 8.33064 40.1901 9.01064 40.1901 10.7006Z"
                fill="#8FD4FF"
              />
            </g>
            <g id="Group_11">
              <path
                id="Vector_23"
                d="M41.1105 11.7199L38.9105 15.6099C38.9105 15.6099 37.3105 14.6899 37.0305 14.5199C36.7405 14.3599 36.5605 13.9999 36.5605 13.4999C36.5605 12.4899 37.2705 11.2599 38.1505 10.7599C38.5905 10.5099 38.9905 10.4799 39.2705 10.6499C39.5605 10.8099 41.1105 11.7199 41.1105 11.7199Z"
                fill="#43BCFF"
              />
              <path
                id="Vector_24"
                d="M41.5306 12.7192C41.5306 13.7292 40.8206 14.9592 39.9406 15.4592C39.0606 15.9692 38.3506 15.5592 38.3506 14.5492C38.3506 13.5392 39.0606 12.3092 39.9406 11.8092C40.8206 11.2992 41.5306 11.7092 41.5306 12.7192Z"
                fill="#8FD4FF"
              />
            </g>
            <g id="Group_12">
              <path
                id="Vector_25"
                d="M41.5004 9.3C41.5004 10.02 40.9204 13.8 40.2004 13.8C39.4804 13.8 38.9004 10.02 38.9004 9.3C38.9004 8.58 39.4804 8 40.2004 8C40.9204 8 41.5004 8.58 41.5004 9.3Z"
                fill="#1FAEF0"
              />
              <path
                id="Vector_26"
                d="M36.3 16.3103C36.76 15.7603 39.65 13.2503 40.2 13.7103C40.75 14.1703 38.75 17.4403 38.29 17.9803C37.83 18.5303 37.01 18.6003 36.46 18.1303C35.91 17.6703 35.84 16.8503 36.31 16.3003L36.3 16.3103Z"
                fill="#1FAEF0"
              />
              <path
                id="Vector_27"
                d="M43.7697 15.2594C43.0597 15.1894 40.1197 14.4594 40.1897 13.7494C40.2597 13.0394 43.3197 12.5994 44.0297 12.6694C44.7397 12.7394 45.2597 13.3794 45.1897 14.0894C45.1197 14.7994 44.4797 15.3194 43.7697 15.2494V15.2594Z"
                fill="#1FAEF0"
              />
              <g id="Group_13">
                <path
                  id="Vector_28"
                  d="M39.0904 14.5398C39.1804 15.3398 39.8304 15.6598 40.5504 15.2398C41.2704 14.8198 41.7704 13.8398 41.6904 13.0298C41.6004 12.2298 40.9504 11.9098 40.2304 12.3298C39.5104 12.7498 39.0104 13.7298 39.0904 14.5398Z"
                  fill="#BA203F"
                />
                <path
                  id="Vector_29"
                  d="M39.5203 15.3104C40.4903 15.8004 41.6603 15.5104 42.1203 14.6604C42.5803 13.8104 42.1603 12.7204 41.1903 12.2204C40.2203 11.7204 38.5503 14.8204 39.5303 15.3104H39.5203Z"
                  fill="#BA203F"
                />
              </g>
            </g>
          </g>
          <g id="Group_14">
            <path
              id="Vector_30"
              d="M32.4105 11.6099C32.4105 12.3499 32.1505 12.8799 31.7205 13.1199C31.3005 13.3599 14.6805 23.1699 14.6805 23.1699L11.3105 17.4599C11.3105 17.4599 27.9805 7.62992 28.4105 7.38992C28.8305 7.14992 29.4205 7.17992 30.0705 7.55992C31.3605 8.30992 32.4105 10.1199 32.4105 11.6099Z"
              fill="#399EFF"
            />
            <path
              id="Vector_31"
              d="M15.3109 21.6895C15.3109 23.1795 14.2609 23.7795 12.9709 23.0295C11.6809 22.2795 10.6309 20.4695 10.6309 18.9795C10.6309 17.4895 11.6809 16.8895 12.9709 17.6395C14.2609 18.3895 15.3109 20.1995 15.3109 21.6895Z"
              fill="#399EFF"
            />
          </g>
          <g id="Group_15">
            <g id="Group_16">
              <path
                id="Vector_32"
                d="M10.1105 12.3412L4.90047 22.0712C4.90047 22.0712 4.01047 21.5012 3.33047 21.0912C2.65047 20.6812 2.23047 19.8012 2.23047 18.5412C2.23047 16.0212 3.92047 12.9512 6.00047 11.6912C7.04047 11.0612 7.98047 10.9912 8.66047 11.4112C9.34047 11.8212 10.1205 12.3612 10.1205 12.3612L10.1105 12.3412Z"
                fill="#399EFF"
              />
              <path
                id="Vector_33"
                d="M11.1201 14.832C11.1201 17.352 9.43008 20.422 7.35008 21.682C5.27008 22.952 3.58008 21.932 3.58008 19.412C3.58008 16.892 5.27008 13.8221 7.35008 12.5621C9.43008 11.2921 11.1201 12.312 11.1201 14.832Z"
                fill="#2C89FF"
              />
            </g>
            <g id="Group_17">
              <path
                id="Vector_34"
                d="M20.1001 20.1617L16.4201 26.6917C16.4201 26.6917 6.38012 20.8517 5.90012 20.5717C5.42012 20.2917 5.12012 19.7017 5.12012 18.8617C5.12012 17.1717 6.31012 15.1117 7.78012 14.2617C8.51012 13.8417 9.18012 13.7917 9.66012 14.0717C10.1401 14.3517 20.1001 20.1617 20.1001 20.1617Z"
                fill="#43BCFF"
              />
              <path
                id="Vector_35"
                d="M20.8102 21.8315C20.8102 23.5215 19.6202 25.5815 18.1502 26.4315C16.6802 27.2815 15.4902 26.6015 15.4902 24.9115C15.4902 23.2215 16.6802 21.1615 18.1502 20.3115C19.6202 19.4615 20.8102 20.1415 20.8102 21.8315Z"
                fill="#8FD4FF"
              />
            </g>
            <g id="Group_18">
              <path
                id="Vector_36"
                d="M21.7199 22.8605L19.5199 26.7505C19.5199 26.7505 17.9199 25.8305 17.6399 25.6605C17.3499 25.5005 17.1699 25.1405 17.1699 24.6405C17.1699 23.6305 17.8799 22.4005 18.7599 21.9005C19.1999 21.6505 19.5999 21.6205 19.8799 21.7905C20.1699 21.9505 21.7199 22.8605 21.7199 22.8605Z"
                fill="#43BCFF"
              />
              <path
                id="Vector_37"
                d="M22.1497 23.8501C22.1497 24.8601 21.4397 26.0901 20.5597 26.5901C19.6797 27.1001 18.9697 26.6901 18.9697 25.6801C18.9697 24.6701 19.6797 23.4401 20.5597 22.9401C21.4397 22.4301 22.1497 22.8401 22.1497 23.8501Z"
                fill="#8FD4FF"
              />
            </g>
            <g id="Group_19">
              <path
                id="Vector_38"
                d="M22.1098 20.4309C22.1098 21.1509 21.5298 24.9309 20.8098 24.9309C20.0898 24.9309 19.5098 21.1509 19.5098 20.4309C19.5098 19.7109 20.0898 19.1309 20.8098 19.1309C21.5298 19.1309 22.1098 19.7109 22.1098 20.4309Z"
                fill="#1FAEF0"
              />
              <path
                id="Vector_39"
                d="M16.9201 27.4411C17.3801 26.8911 20.2701 24.3811 20.8201 24.8411C21.3701 25.3011 19.3701 28.5711 18.9101 29.1111C18.4501 29.6511 17.6301 29.7311 17.0801 29.2611C16.5301 28.8011 16.4601 27.9811 16.9301 27.4311L16.9201 27.4411Z"
                fill="#1FAEF0"
              />
              <path
                id="Vector_40"
                d="M24.3898 26.3903C23.6798 26.3203 20.7398 25.5903 20.8098 24.8803C20.8798 24.1703 23.9398 23.7303 24.6498 23.8003C25.3598 23.8703 25.8798 24.5103 25.8098 25.2203C25.7398 25.9303 25.0998 26.4503 24.3898 26.3803V26.3903Z"
                fill="#1FAEF0"
              />
              <g id="Group_20">
                <path
                  id="Vector_41"
                  d="M19.7105 25.6706C19.8005 26.4706 20.4505 26.7906 21.1705 26.3706C21.8905 25.9506 22.3905 24.9706 22.3105 24.1606C22.2205 23.3606 21.5705 23.0406 20.8505 23.4606C20.1305 23.8806 19.6305 24.8606 19.7105 25.6706Z"
                  fill="#BA203F"
                />
                <path
                  id="Vector_42"
                  d="M20.1405 26.4511C21.1105 26.9411 22.2805 26.6511 22.7405 25.8011C23.2005 24.9511 22.7805 23.8611 21.8105 23.3611C20.8405 22.8711 19.1705 25.9611 20.1505 26.4511H20.1405Z"
                  fill="#BA203F"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2787_13256">
        <rect width="207.1" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
